
export enum VideoMode {
    NONE = 0,
    PLAYERS_ONLY = 1,
    PLAYERS_SPECTATORS_LISTEN = 2,
    PLAYERS_AND_SPECTATORS = 3,
    CAST_NORTH = 4, // must be 4 aligned, so we can use % 4
    CAST_EAST = 5, // but still not implemented.... maybe obsolete
    CAST_SOUTH = 6,
    CAST_WEST = 7,
    CAST_DESIGNATED = 8, // username
};